import type { ClientFlowAction } from '~/graphql/types.client';

/**
 * Returns the actions that have no children *within the provided subset*.
 * In other words: "lowest level" == leaf nodes inside the copied branch.
 */
const getActionsOnLowestLevel = (
  actions: Array<ClientFlowAction>,
): Array<ClientFlowAction> => {
  const ids = new Set(actions.map(a => a.id));
  const idsThatHaveDirectChildren = new Set<string>();

  for (const action of actions) {
    if (action.__typename === 'FlowV2_Action_Start') continue;
    if (!('parentIds' in action)) continue;

    for (const parentId of action.parentIds) {
      if (ids.has(parentId) && action.parentIds[0] === parentId)
        idsThatHaveDirectChildren.add(parentId);
    }
  }

  // The loop above only marks parentIds[0] as having a child, so it misses the
  // IfElse in that case. Explicitly check trueChildId/falseChildId so an IfElse
  // with a portal on its path is never misidentified as a leaf.
  for (const action of actions) {
    if (action.__typename !== 'FlowV2_Action_IfElse') continue;
    if (action.trueChildId && ids.has(action.trueChildId))
      idsThatHaveDirectChildren.add(action.id);
    if (action.falseChildId && ids.has(action.falseChildId))
      idsThatHaveDirectChildren.add(action.id);
  }

  return actions.filter(action => !idsThatHaveDirectChildren.has(action.id));
};

export default getActionsOnLowestLevel;
